<template>
  <div class="pick-calendar" v-loading="loading">
    <div ref="calEl" class="pick-calendar__fc" />
  </div>
</template>

<script>
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import multiMonthPlugin from '@fullcalendar/multimonth'
import zhCnLocale from '@fullcalendar/core/locales/zh-cn'
import { fetchPickRows } from '@/utils/pickAdapter'

function toFcDate(v) {
  if (!v) return null
  const s = String(v).trim()
  if (!s) return null
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10)
  const d = new Date(s)
  if (Number.isNaN(d.getTime())) return null
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export default {
  name: 'PickCalendar',
  data() {
    return { loading: false, calendar: null }
  },
  mounted() {
    this.initCalendar()
  },
  beforeDestroy() {
    if (this.calendar) {
      this.calendar.destroy()
      this.calendar = null
    }
  },
  activated() {
    if (this.calendar) this.calendar.updateSize()
  },
  methods: {
    async initCalendar() {
      this.loading = true
      let events = []
      try {
        const rows = await fetchPickRows()
        events = rows
          .map(r => {
            const start = toFcDate(r.pickDateFrom)
            if (!start) return null
            const end = toFcDate(r.pickDateTo)
            const ev = {
              id: String(r.id),
              title: r.caseName || r.xmmc || r.xmbh || '采样任务',
              start,
              allDay: true,
              backgroundColor: '#3BB2E3',
              borderColor: '#3BB2E3',
              extendedProps: { xmbh: r.xmbh, row: r }
            }
            if (end && end !== start) {
              // FullCalendar end 为排他，+1 天展示区间
              const d = new Date(end + 'T00:00:00')
              d.setDate(d.getDate() + 1)
              const pad = n => String(n).padStart(2, '0')
              ev.end = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
            }
            return ev
          })
          .filter(Boolean)
      } catch (e) {
        /* ignore */
      } finally {
        this.loading = false
      }

      const el = this.$refs.calEl
      if (!el) return
      if (this.calendar) {
        this.calendar.destroy()
        this.calendar = null
      }

      this.calendar = new Calendar(el, {
        plugins: [dayGridPlugin, timeGridPlugin, listPlugin, multiMonthPlugin],
        initialView: 'dayGridMonth',
        firstDay: 1,
        locale: zhCnLocale,
        themeSystem: 'standard',
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,multiMonthYear,timeGridWeek,timeGridDay,listYear'
        },
        buttonText: {
          today: '今天',
          multiMonthYear: '年',
          dayGridMonth: '月',
          timeGridWeek: '周',
          timeGridDay: '日',
          listYear: '列表'
        },
        allDayText: '全天',
        slotLabelFormat: {
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false,
          hour12: false
        },
        height: 'auto',
        navLinks: true,
        editable: false,
        selectable: true,
        eventDisplay: 'list-item',
        events,
        eventClick: arg => {
          const xmbh = arg.event.extendedProps && arg.event.extendedProps.xmbh
          if (xmbh) this.$router.push({ path: '/pick/batch-contract', query: { xmbh } })
          else this.$router.push('/pick/doing')
        }
      })
      this.calendar.render()
    }
  }
}
</script>

<style scoped>
.pick-calendar {
  height: 100%;
  overflow: auto;
  background: #fff;
  padding: 8px 12px 16px;
}
.pick-calendar__fc {
  min-height: 480px;
}
.pick-calendar >>> .fc-event {
  cursor: pointer;
}
</style>
